import { Router } from '@angular/router';
import { HttpInterceptorFn } from '@angular/common/http';
import { Auth, signOut} from '@angular/fire/auth';
import { catchError, from, switchMap, throwError } from 'rxjs';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { LoadingService } from '../services/loading.service';

export const httpRequestInterceptor: HttpInterceptorFn = (req, next) => {

  const auth = inject(Auth);


  return from(auth.currentUser?.getIdToken(true) || Promise.resolve(null)).pipe(
    switchMap((token) => {
      //console.log("httpRequestInterceptor!")
      // Clono la request
      let clonedRequest = req.clone({
      });

      if (token) {
        clonedRequest = clonedRequest.clone({
          setHeaders: {
            Authorization: `Bearer ${token}`,
          },
        });
      }

      return next(clonedRequest).pipe(
        catchError((error) => {
          // Controlla se lo status è 401
          if (error.status === 401) {
            console.error('Unauthorized request:', error);

            const router = inject(Router);
            router.navigate(['/login']);
          }

          // Propaga l'errore
          return throwError(() => error);
        })
      );;
    }),
    catchError((error) => {
      console.error('Error refreshing token:', error);

      // Azioni personalizzate in caso di errore nel refresh del token
      if (error.code === 'auth/network-request-failed') {
        console.error('Network issue. Token refresh failed.');
      } else if (error.code === 'auth/user-token-expired' || error.code === 'auth/id-token-expired') {
        console.error('Token expired. Logging out the user.');
        const authService = inject(AuthService);
        authService.logOut().then(
          () => {
            const router = inject(Router);
            router.navigate(['/login']);
          }

        )
      } else {
        console.error('Unhandled token refresh error:', error.message);
      }


      // Propaga l'errore alla richiesta HTTP
      return throwError(() => error);
    })
  );

};


